import React from 'react';

const variantStyles = {
  primary: 'inline-flex items-center justify-center px-4 py-2 rounded-full border border-transparent bg-black dark:bg-white shadow-md text-base font-medium whitespace-nowrap text-white dark:text-black hover:bg-gray-800 dark:hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:focus:ring-gray-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900 transition-colors',
  secondary: 'relative inline-flex items-center justify-center px-4 py-2 rounded-full border border-transparent bg-purple-100 dark:bg-purple-900/30 shadow-md text-base font-medium whitespace-nowrap text-purple-700 dark:text-purple-300 hover:bg-purple-200 dark:hover:bg-purple-900/50 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 transition-colors',
  outline: 'inline-flex items-center justify-center px-4 py-2 rounded-full border border-purple-300 dark:border-purple-600 shadow-sm text-sm font-medium whitespace-nowrap text-purple-600 dark:text-purple-400 bg-white dark:bg-gray-800 hover:bg-purple-50 dark:hover:bg-purple-900/20 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 transition-colors',
};

const Button = ({ variant = 'primary', className = '', as = 'button', children, ...props }) => {
  const Element = as;
  
  const combinedClassName = `${variantStyles[variant]} ${className}`;
  
  // Handle smooth scrolling for anchor links
  const handleClick = (e) => {
    if (props.href && props.href.startsWith('#')) {
      e.preventDefault();
      const targetId = props.href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    
    // Call the original onClick if it exists
    if (props.onClick) {
      props.onClick(e);
    }
  };
  
  return (
    <Element 
      className={combinedClassName} 
      onClick={handleClick}
      {...props}
    >
      {children}
    </Element>
  );
};

export default Button;